// Angular
import { Component, Input, OnChanges, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { IComboboxOption } from '../combobox-field/combobox-field.component';
import { IFieldSpecs } from '../interfaces/field-specs';
import { MatSelect } from "@angular/material/select";
import { MatOption, MatPseudoCheckboxState } from "@angular/material/core";

@Component({
    selector: 'multi-combobox',
    template: `
        <form-field *ngIf="fieldConfig"
            [options]="fieldConfig"
            [formGroup]="fieldConfig.formGroup"
            [isFull]="isFull">
            <mat-select #matSelectElement
                        [formControlName]="fieldConfig.formControlName"
                        [placeholder]="fieldConfig.placeholder"
                        [class.dropdown-color-white]="dropdownColorWhite"
                        [disabled]="fieldConfig.disabled"
                        [panelClass]="additionnalClasses"
                        (closed)="clearField()"
                        (focus)="openPanel()"
                        multiple>
                <div class="mat-option tooling-option">
                    <!-- TODO NG UPGRADE mat-pseudo-checkbox
                    <mat-pseudo-checkbox [state]="isAllSelected" (click)="toogleAllSelectionCheckbox()"></mat-pseudo-checkbox>
                    -->
                    <text class="option-label" [fieldConfig]="filterFieldConfig"></text>
                </div>
                <div class="mat-select-panel">
                    <mat-option *ngFor="let item of optionList; trackBy: trackByFn"
                        #matOptionElement
                        class="mat-option"
                        [value]="item.value">
                        <span class="option-label">{{ item.label }}</span>
                    </mat-option>
                </div>
            </mat-select>
        </form-field>
    `,
    styleUrls: ["../combobox-field/combobox-field.component.scss", "./multi-combobox.component.scss"]
})
export class MultiComboboxComponent implements OnChanges{

    @Input()
    public fieldConfig: IFieldSpecs;

    @Input()
    public items: IComboboxOption[] = [];
    @Input()
    public isFull: boolean = false;

    public optionList: IComboboxOption[];

    public additionnalClasses: string[] = ["multi-combobox-class"];

    @Input()
    public dropdownColorWhite: boolean = false;

    @ViewChild('matSelectElement')
    public readonly matSelectElement: MatSelect;

    @ViewChildren('matOptionElement')
    public readonly matOptionElement: QueryList<MatOption>;

    public isAllSelected: MatPseudoCheckboxState = 'unchecked';
    public filterFieldConfig: IFieldSpecs;
    public selectAllFormGroup: FormGroup = new FormGroup({
        selectAllflag: new FormControl('')
    })

    public labels: ILabels = {
        selectAll: Yii.t('wui-shared-js', "Tout sélectionner"),
        unSelectAll: Yii.t('wui-shared-js', "Tout désélectionner"),
    };

    public ngOnChanges(changes: SimpleChanges): void {

        if(changes.fieldConfig && changes.fieldConfig.currentValue){
            if(this.fieldConfig.disabled){
                this.fieldConfig.formGroup.disable({emitEvent: false});
            }else{
                this.fieldConfig.formGroup.enable({emitEvent: false});
            }
        }
        this.filterFieldConfig = initFilterFieldSpecs();
        this.optionList = this.items;
        this.listenFilterFormGroup();
    }

    public trackByFn(index: number): number{
        return index;
    }

    public toogleAllSelectionCheckbox(): void{
        this.isAllSelected = this.isAllSelected === 'unchecked' ? 'checked' : 'unchecked';
        const newFormValue: string[] = this.isAllSelected === 'checked' ?
            this.optionList.map(({ value }: IComboboxOption) => value) : [];
        this.fieldConfig.formGroup
            .get(this.fieldConfig.formControlName)
            .patchValue(newFormValue);
    }

    public clearField() :void{
        this.filterFieldConfig.formGroup
            .get(this.filterFieldConfig.formControlName)
            .patchValue('');
    }

    public openPanel(): void{
        this.matSelectElement.open();
    }

    private listenFilterFormGroup(): void{
        this.filterFieldConfig.formGroup.valueChanges
            .pipe(
                debounceTime(10),
                distinctUntilChanged(),
            )
            .subscribe({
                next: ({ filterValue }: { filterValue: string; }): void => {
                    this.optionList = this.items
                        .filter(({ label }: IComboboxOption) => {
                            const labelString: string = label as string;
                            return labelString
                                .toLowerCase()
                                .includes(filterValue.toLowerCase());
                        });
                }
            });
    }
}

function initFilterFieldSpecs(): IFieldSpecs {
    return {
        formControlName: "filterValue",
        formGroup: new FormGroup({
            filterValue: new FormControl('')
        }),
        placeholder: Yii.t('wui-shared-js', " Filtrer"),
        className: "full-width no-border",
    };
}
